import { ReactNode } from "react"
import { cn } from "~/ui-rtk/utils/tailwind-utils"
import DOMPurify from "dompurify"

interface SystemNotificationProps {
  title?: ReactNode
  content: ReactNode
  injectable?: boolean
}

export default function SystemNotification({
  title,
  content,
  injectable = true,
}: SystemNotificationProps) {
  const cleanContent = DOMPurify.sanitize(content as string)
  return (
    <div
      className={cn(
        "transition-all duration-200 ease-in-out bg-system-blue-800 rounded-system-md p-system-md",
      )}
    >
      <div className="flex items-start gap-system-sm text-basic-white">
        <div className="flex-1 min-w-0">
          {title && <div className="font-semibold text-white">{title}</div>}
          <div className={cn("text-basic-white/90", title && "mt-1")}>
            {injectable ? (
              <div
                dangerouslySetInnerHTML={{
                  __html: cleanContent,
                }}
              />
            ) : (
              content
            )}
          </div>
        </div>
      </div>
    </div>
  )
}
